<template>
  <header class="header bg">
    <div class="header-top">
      <div class="header-top-container">
        <div class="header-top-l">
          <img
            class="logo"
            src="https://static3.freshin.online/sku/MhU6EcFPoRN5Ppnb9Wg-1-KU5bI%3D"
            alt
          />
        </div>
        <div class="header-top-r">
          <div class="pc-nav">
            <div class="pc-nav-flex">
              <nav>
                <ul class="nav">
                  <router-link tag="li" active-class="nav-active" to="/home">{{ $t("header.nav1") }}</router-link>
                  <router-link
                    tag="li"
                    active-class="nav-active"
                    to="/content"
                  >{{ $t("header.nav2") }}</router-link>
                  <router-link
                    tag="li"
                    active-class="nav-active"
                    to="/partner"
                  >{{ $t("header.nav3") }}</router-link>
                  <router-link
                    tag="li"
                    active-class="nav-active"
                    to="/about"
                  >{{ $t("header.nav4") }}</router-link>
                </ul>
              </nav>
              <div class="i18">
                <span
                  @click.stop="changeLanuageZh"
                  :class="{'i18-hidden':this.$i18n.locale=='en'}"
                >中文</span>
                <span>|</span>
                <span
                  @click.stop="changeLanuageEn"
                  :class="{'i18-hidden':this.$i18n.locale=='zh'}"
                >English</span>
              </div>
            </div>
          </div>

          <div class="mobile-nav">
            <div class="mobile-nav-icon" @click.stop="showMobileNav">
              <svg width="100%" height="100%" viewBox="0 0 60 60" preserveAspectRatio="none">
                <g id="icon-grid" fill="#fff">
                  <rect x="4.5" y="2.5" width="50" height="5" />
                  <rect x="4.5" y="22.5" width="50" height="5" />
                  <rect x="4.5" y="42.5" width="50" height="5" />
                </g>
                <g id="icon-cross">
                  <line x1="4.5" y1="55.5" x2="54.953" y2="5.046" />
                  <line x1="54.953" y1="55.5" x2="4.5" y2="5.047" />
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <slot></slot>
    </div>
    <div class="mobile-nav-block" :style="{height:mobileNavH}">
      <div class>
        <ul class="mobile-nav-ul">
          <router-link tag="li" to="/home">{{ $t("header.nav1") }}</router-link>
          <router-link tag="li" to="/content">{{ $t("header.nav2") }}</router-link>
          <router-link tag="li" to="/partner">{{ $t("header.nav3") }}</router-link>
          <router-link tag="li" to="/about">{{ $t("header.nav4") }}</router-link>
          <li>
            <span @click.stop="changeLanuageZh" :class="{'i18-hidden':this.$i18n.locale=='en'}">中文</span>
            <span>|</span>
            <span
              @click.stop="changeLanuageEn"
              :class="{'i18-hidden':this.$i18n.locale=='zh'}"
            >English</span>
          </li>
        </ul>
      </div>
      <div @click.stop="hiddenMobileNav" class="mobile-nav-close-icon">
        <svg width="100%" height="100%" viewBox="0 0 60 60" preserveAspectRatio="none">
          <g id="icon-cross">
            <line x1="4.5" y1="55.5" x2="54.953" y2="5.046" />
            <line x1="54.953" y1="55.5" x2="4.5" y2="5.047" />
          </g>
        </svg>
      </div>
    </div>
  </header>
</template>

<script>
import { setup } from "./../i18n/index.js";
export default {
  data() {
    return {
      mobileNavH: "0px"
    };
  },
  methods: {
    showMobileNav: function() {
      document.body.style.overflow = "hidden";
      this.mobileNavH = "100%";
    },
    hiddenMobileNav: function() {
      document.body.style.overflow = "scroll";
      this.mobileNavH = "0px";
    },
    changeLanuageZh: function() {
      setup("zh");
    },
    changeLanuageEn: function() {
      setup("en");
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .mobile-nav {
    display: block !important;
  }
  .pc-nav {
    display: none !important;
  }
}
@media screen and (min-width: 768px) {
  .mobile-nav {
    display: none !important;
  }
  .pc-nav {
    display: block !important;
  }
}
.logo {
  width: 6rem;
}
.header-top {
}
.header-top-container {
  display: flex;
  justify-content: space-between;
  padding: 0 10%;
}
.bg {
  background-attachment: fixed;
  height: 42.78rem;
  background-size: cover;
}
.header-top {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  padding-top: 1.75rem;
}
.header-top-l {
}
.header-top-r {
  /* display: flex; */
}
.pc-nav-flex {
  display: flex;
}
.nav {
  /* margin-right: 3.6rem; */
  height: 2rem;
  display: flex;
  font-size: 0.88rem;
  color: #ffffff;
}
.nav li {
  cursor: pointer;
  font-size: 0.88rem;
  margin-right: 1.5rem;
  position: relative;
  width: 4.5rem;
  text-align: center;
}
.nav li:last-child {
  margin-right: 3.63rem;
}
.nav-active::after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 0.25rem;
  background-color: #fff;
}
.mobile-nav-block {
  z-index: 1000;
  overflow: hidden;
  position: fixed;
  /* display: none; */
  /* height: 100%; */
  width: 100%;
  background-color: #ffffff;
  left: 0;
  right: 0;
  top: 0;
  transition: all 0.6s;
}
.mobile-nav-ul {
  padding-top: 10rem;
  font-size: 2rem;
  text-align: center;
}
.mobile-nav-ul li {
  height: 6rem;
  line-height: 6rem;
  cursor: pointer;
}
.mobile-nav-close-icon {
  margin-right: 10%;
  margin-bottom: 5%;
  stroke: #333;
  stroke-width: 2px;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 2.4rem;
}
.mobile-nav-icon {
  width: 2.4rem;
}
.i18 {
  cursor: pointer;
  /* position: absolute;
  right: 1.6rem;
  top: 1.75rem; */
  font-size: 0.88rem;
  height: 2rem;
  color: #ffffff;
}
.i18-hidden {
  opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// headers.vue?178edda3